var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 60,
    viewBox: "0 0 417 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.742 42.2535H398.204L406.228 23.3516H408.937L417 42.2535H414.291L411.845 36.3054H405.593L406.267 34.3226H411.026L407.496 25.7573L400.742 42.2535Z",
    fill: "#DAAF51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375.869 42.2535H373.331L381.354 23.3516H384.064L392.127 42.2535H389.418L386.972 36.3054H380.72L381.394 34.3226H386.153L382.623 25.7573L375.869 42.2535Z",
    fill: "#DAAF51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.93 23.3516V42.2535H362.484V23.3516H364.93Z",
    fill: "#DAAF51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335.843 42.2535V23.3516H338.288L349.854 38.5789V23.3516H352.167V42.2535H349.722L338.156 26.894V42.2535H335.843Z",
    fill: "#DAAF51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M326.529 23.3516V25.3343H316.615V31.679H326.066V33.6617H316.615V40.2708H326.727V42.2535H314.17V23.3516H326.529Z",
    fill: "#DAAF51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.643 32.8025L288.201 23.3516H291.175L297.123 30.9124L303.072 23.3516H306.046L298.617 32.8025L306.046 42.2535H303.072L297.123 34.6927L291.175 42.2535H288.201L295.643 32.8025Z",
    fill: "#DAAF51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.849 42.2535V23.3516H254.294L265.86 38.5789V23.3516H268.173V42.2535H265.728L254.162 26.894V42.2535H251.849Z",
    fill: "#DAAF51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.33 32.751C226.33 37.8532 228.635 40.4043 233.244 40.4043C237.755 40.4043 240.011 37.8532 240.011 32.751C240.011 27.7193 237.755 25.2034 233.244 25.2034C228.635 25.2034 226.33 27.7193 226.33 32.751ZM223.753 32.8303C223.753 26.4239 226.916 23.2207 233.244 23.2207C239.474 23.2207 242.589 26.4239 242.589 32.8303C242.589 39.2015 239.474 42.387 233.244 42.387C226.916 42.387 223.753 39.2015 223.753 32.8303Z",
    fill: "#DAAF51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 23.3516V42.2535H211.649V23.3516H214.095Z",
    fill: "#DAAF51"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M185.272 42.2535V23.3516H187.718V31.679H198.887V23.3516H201.333V42.2535H198.887V33.6617H187.718V42.2535H185.272Z",
    fill: "#DAAF51"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M175.813 41.5939C174.183 42.1227 172.421 42.387 170.526 42.387C163.917 42.387 160.612 39.1045 160.612 32.5395C160.612 26.327 163.917 23.2207 170.526 23.2207C172.421 23.2207 174.183 23.4851 175.813 24.0138V26.1287C174.183 25.5119 172.509 25.2034 170.79 25.2034C165.635 25.2034 163.058 27.6488 163.058 32.5395C163.058 37.7827 165.635 40.4043 170.79 40.4043C172.509 40.4043 174.183 40.0959 175.813 39.479V41.5939Z",
    fill: "#DAAF51"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.315 23.3516V40.2708H153.203V42.2535H140.87V23.3516H143.315Z",
    fill: "#DAAF51"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.619 42.2535H114.081L122.104 23.3516H124.814L132.877 42.2535H130.168L127.722 36.3054H121.47L122.144 34.3226H126.903L123.373 25.7573L116.619 42.2535Z",
    fill: "#DAAF51"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.663 23.3516V25.3343H97.7491V31.679H107.2V33.6617H97.7491V42.2535H95.3037V23.3516H107.663Z",
    fill: "#DAAF51"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.645562 0.335938C3.70655 14.4141 36.017 17.4308 31.2555 37.0396C22.0724 21.4531 -4.45599 16.928 0.645562 0.335938Z",
    fill: "#DAAF51"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57728 18.4364C6.08744 22.347 10.951 30.9391 26.324 34.0229C24.4534 27.319 9.14843 21.2855 5.57728 18.4364Z",
    fill: "#DAAF51"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6789 29.1626C10.7077 29.2505 10.7393 29.3407 10.7739 29.4331C12.4289 32.9355 29.9162 34.6752 30.7454 40.5592C17.7514 39.7751 12.1018 32.9839 10.7739 29.4331C10.7318 29.3441 10.7 29.254 10.6789 29.1626Z",
    fill: "#DAAF51"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1105 0.503534C81.0495 14.5817 48.7391 17.5984 53.5006 37.2072C62.6837 21.6207 89.2121 17.0956 84.1105 0.503534Z",
    fill: "#DAAF51"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.519 18.4364C79.0089 22.347 74.1453 30.9391 58.7723 34.0229C60.6429 27.319 75.9479 21.2855 79.519 18.4364Z",
    fill: "#DAAF51"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4174 29.1626C74.3886 29.2505 74.357 29.3407 74.3224 29.4331C72.6674 32.9355 55.1801 34.6752 54.3509 40.5592C67.3449 39.7751 72.9945 32.9839 74.3224 29.4331C74.3644 29.3441 74.3963 29.254 74.4174 29.1626Z",
    fill: "#DAAF51"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0375 45.2519V32.8497L42.5138 41.5647L47.7509 33.6877V45.9223L57.274 52.2909L52.6825 56.8161L45.8803 48.7714L49.4515 57.9892L43.8397 59.6652L41.9691 49.4418L40.9487 59.6652L35.677 57.9892L38.568 48.7714L32.1059 56.8161L27.5144 51.7881L37.0375 45.2519Z",
    fill: "#DAAF51"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4121 22.4587C37.4121 25.2355 39.6962 27.4866 42.5138 27.4866C45.3313 27.4866 47.6154 25.2355 47.6154 22.4587H51.0491L42.36 37.291L33.6709 22.4587H37.4121Z",
    fill: "#DAAF51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.642edcc73640a3698ce91c2c022dd6a7.svg";
export { ForwardRef as ReactComponent };